import { Injectable } from '@angular/core'
import { environment } from '@employer/environments/environment'
import {
  BaseCustomerConfigProvider,
  CustomerPartitionConfigProvider,
  ICustomerConfig,
  ICustomerPartitionConfig,
  ICustomerPartitionConfigProvider,
} from '@engineering11/customer-web'
import { E11Logger } from '@engineering11/web-api-error'
import { Store } from '@ngrx/store'
import { selectors } from '../store/selectors'

@Injectable({ providedIn: 'root' })
export class EmployerCustomerConfigProvider extends BaseCustomerConfigProvider {
  constructor(private store: Store, private logger: E11Logger) {
    super()
  }
  get config(): ICustomerConfig {
    return {
      baseUrl: environment.services.customer, // update when partitions are ready
      token$: this.store.select(selectors.getCurrentToken),
      customerKey$: this.store.select(selectors.getCustomerKey$), // the current user's customerKey
    }
  }
}

@Injectable({ providedIn: 'root' })
export class EmployerCustomerPartitionConfigProvider extends CustomerPartitionConfigProvider implements ICustomerPartitionConfigProvider {
  get config(): ICustomerPartitionConfig {
    return {
      listOfPartitionsUrl: '/company/partition-tabs',
      basePartitionPartial: '/apps',
    }
  }
}
